export default "__VITE_ASSET__e95b32d5__"